import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MarkLayout from "layout/MarkLayout";
import {Button, Popconfirm, Modal, Tabs, message, Tag} from "antd";
import { CheckOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { action } from "store/Score";
import { validateScore } from "store/Score/action";
import ScoreTableSheet from "./ScoreTableSheet";
import { isCurrentRoundDraft } from "utils/copyScore";

const StyledTaskPage = styled.div`
  position: relative;

  .sheet {
    //margin-top: 1em;
    padding: 8px 1em;
    background: #fff;
    box-shadow: 0px 0px 2px 0px #bdbdbd;
  }

  .score-tabs {
    //margin-top: 1em;
  }

  .score-tabs .ant-tabs-nav {
    margin: 0;
  }

  /* 右下角浮动提交按钮 */
  .submit-affix {
    position: fixed;
    right: 1.5em;
    bottom: 1em;
    z-index: 999;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
      0px 6px 10px 0px rgba(0, 0, 0, 0.14),
      0px 1px 18px 0px rgba(0, 0, 0, 0.12);
    border-radius: 40px;
  }
`;

/**
 * 任务列表 + 评分页（项目级多表 Tabs + 动态层级表格）
 * 登录后直接进入本页：所有评分表以 tab 展示，点击切换，右下角提交当前表。
 */
class TaskPage extends React.PureComponent {
  componentDidMount() {
    this.props.loadProject(this.props.match.params.id);
  }

  /**
   * 切换 tab 前：仅当"校验全部通过 且 未提交"时才弹窗确认是否提交。
   * - 已提交（status=1）→ 直接切换
   * - 无本地自动保存内容（=从未填写过数值）→ 直接切换，不弹窗
   * - 校验不通过（有填写但分值和不对/未填完）→ 直接切换，不弹窗
   * - 校验通过 + 未提交 → Modal.confirm："当前评分表尚未提交，请确认是否提交？"
   */
  handleTabChange = (key) => {
    const { projectInfo, activeTableId, tablesMap } = this.props;
    if (String(key) === String(activeTableId)) return;
    const currentTableInfo = tablesMap.get(String(activeTableId));
    const tables = projectInfo.get("tables");
    const currentItem =
      tables &&
      tables.find((t) => String(t.get("id")) === String(activeTableId));
    const scored = !!(currentItem && currentItem.get("status"));

    const hasDraft = isCurrentRoundDraft(
      activeTableId,
      projectInfo.get("status")
    );

    if (scored || !hasDraft || !currentTableInfo || !validateScore(currentTableInfo)) {
      this.props.switchTable(key);
      return;
    }

    Modal.confirm({
      title: "提示",
      content: "当前评分表尚未提交，请确认是否提交？",
      okText: "确定",
      cancelText: "取消",
      maskClosable: false,
      onOk: () => {
        this.props.submitScore(currentTableInfo, projectInfo, true);
      },
      onCancel: () => {
        this.props.dismissAutoSave(String(activeTableId));
        this.props.switchTable(key);
      }
    });
  };

  /**
   * 提交当前评分表：校验通过后才提交（校验逻辑与切换 tab 一致）。
   * 点击「提交」→ Popconfirm 确认 → 此处执行。
   */
  handleSubmit = () => {
    const { projectInfo, activeTableId, tablesMap } = this.props;
    const currentTableInfo = tablesMap.get(activeTableId);

    if (!currentTableInfo) {
      message.warning("当前评分表尚未加载完成");
      return;
    }
    this.props.trySubmit(currentTableInfo, projectInfo);
  };

  render() {
    const {
      projectInfo,
      tablesMap,
      activeTableId,
      canLoadSave,
      copyPrompt
    } = this.props;

    const tables = projectInfo.get("tables").toArray();
    const currentTableInfo = tablesMap.get(activeTableId);

    const copyNames = copyPrompt.get("targetNames");
    const copyPromptText =
      copyNames && copyNames.size
        ? `是否将数据复制到${copyNames.join("、")}？`
        : "是否将数据复制到其他评分表？";

    const okTagStyle = {
      marginLeft: 8,
      color: "#52c41a",
      background: "#f6ffed",
      borderColor: "#b7eb8f"
    };

    return (
      <MarkLayout
        fullWidth
        title={projectInfo.get("title")}
        description={
          <span>
            第{projectInfo.get("status")}轮打分 <br />
            {this.props.userInfo.get("name")}专家您好！ <br />
            共有 {tables.length} 张表需要您打分，目前剩余{" "}
            {tables.filter((t) => !t.get("status")).length} 张未评分。
            <br />
            注：您可以对已评分的表进行修改，提交前请确保当前表分值合计为 100。
            {projectInfo.get("status") === 2  &&  <> <br />当前建议分值为上一轮评分的均值，默认值为您上轮的评分</>}
          </span>
        }
        content={
          <StyledTaskPage>
            <Modal
              visible={canLoadSave}
              title="是否加载自动保存内容"
              onOk={() => {
                this.props.loadAutoSave(activeTableId);
              }}
              onCancel={() => {
                this.props.dismissAutoSave(activeTableId);
              }}
            >
              <p>检测到有自动保存的内容，是否加载？</p>
            </Modal>

            <Modal
              visible={copyPrompt.get("visible")}
              title="复制评分数据"
              okText="是"
              cancelText="否"
              onOk={() => {
                this.props.confirmCopy(currentTableInfo, projectInfo);
                this.props.submitScore(currentTableInfo, projectInfo);
              }}
              onCancel={() => {
                this.props.cancelCopy();
                this.props.submitScore(currentTableInfo, projectInfo);
              }}
            >
              <p>{copyPromptText}</p>
            </Modal>

            <Tabs
              className="score-tabs"
              activeKey={activeTableId}
              onChange={this.handleTabChange}
            >
              {tables.map((t) => (
                <Tabs.TabPane
                  tab={
                    t.get("status") ? (
                      <span>
                        {t.get("title")}
                        <Tag style={okTagStyle}>已评分</Tag>
                      </span>
                    ) : (
                      t.get("title")
                    )
                  }
                  key={String(t.get("id"))}
                >
                  <div className="sheet">
                    <ScoreTableSheet
                      tableId={String(t.get("id"))}
                      rounds={projectInfo.get("status")}
                      handleSubmit={this.handleSubmit}
                    />
                  </div>
                </Tabs.TabPane>
              ))}
            </Tabs>

            <div className="submit-affix">
              <Popconfirm
                title="提交评分？"
                onConfirm={this.handleSubmit}
                okText="确定"
                cancelText="再看看"
              >
                <Button
                  type="primary"
                  shape="round"
                  size="large"
                  icon={<CheckOutlined />}
                >
                  提交
                </Button>
              </Popconfirm>
            </div>
          </StyledTaskPage>
        }
      />
    );
  }
}

const STP = (state) => {
  const score = state.get("score");
  return {
    userInfo: score.get("userInfo"),
    projectInfo: score.get("projectInfo"),
    canLoadSave: score.get("canLoadSave"),
    copyPrompt: score.getIn(["modal", "copyPrompt"]),
    tablesMap: score.get("tablesMap"),
    activeTableId: score.get("activeTableId")
  };
};

const DTP = (dispatch) => {
  return {
    loadProject: (projectId) => {
      dispatch(action.loadProject(projectId));
    },
    loadAutoSave: (tableId) => {
      dispatch(action.loadAutoSave(tableId));
    },
    dismissAutoSave: (tableId) => {
      dispatch(action.dismissAutoSave(tableId));
    },
    changeItem: (target, value) => {
      dispatch(action.changeItem(target, value));
    },
    switchTable: (tableId) => {
      dispatch(action.switchTable(tableId));
    },
    confirmCopy: (currentTableInfo, projectInfo) => {
      dispatch(action.confirmCopy(currentTableInfo, projectInfo));
    },
    cancelCopy: () => {
      dispatch(action.cancelCopy());
    },
    submitScore: (currentTableInfo, projectInfo) => {
      dispatch(action.submitScore(currentTableInfo, projectInfo));
    },
    trySubmit: (currentTableInfo, projectInfo) => {
      dispatch(action.trySubmit(currentTableInfo, projectInfo));
    }
  };
};

export default withRouter(connect(STP, DTP)(TaskPage));
